<div (click)="onUpload(); $event.preventDefault();">
  <div class="-hidden">
    <input #upload (change)="onChange($event)" type="file" class="upload" [accept]="acceptedFiles" data-cy="file">
  </div>
  <ng-content></ng-content>
</div>
